// extracted by mini-css-extract-plugin
export default {"root":"eqfpBRGKbf6FUslmise7","back":"tNpW9IcANOxSoqY_C2p4","body":"ZvGLDNR7aPH_ynu8IiXz"};